import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Legal.scss';

const Privacy = () => {
  return (
    <>
      <Header />
      <div className="legal-container">
        <div className="legal-content">
          <Link to="/" className="back-link">
            <FiArrowLeft />
            <span>Back to Home</span>
          </Link>

          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-updated">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <div className="legal-section">
  <h2>1. Introduction</h2>
  <p>
    INVITS (“we,” “our,” or “us”) is a product owned and operated by <strong>Forte Technologies</strong>.
    This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Service.
  </p>
  <p>
    By using INVITS, you agree to the collection and use of information in accordance with this policy.
  </p>
</div>

          <div className="legal-section">
            <h2>2. Information We Collect</h2>
            <h3>2.1 Personal Information</h3>
            <p>We collect information that you provide directly to us, including:</p>
            <ul>
              <li><strong>Account Information:</strong> Name, username, email, phone, and password</li>
              <li><strong>Profile Information:</strong> Birthday, gender, location</li>
              <li><strong>Event & Invitation Information:</strong> Event details, guest lists, RSVP responses</li>
              <li><strong>Community Information:</strong> Memberships, community interactions, fees paid</li>
              <li><strong>Payment Information:</strong> Billing details via secure processors</li>
              <li><strong>Communications:</strong> Messages, feedback, and support inquiries</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <ul>
              <li>Device type, OS, browser, unique identifiers</li>
              <li>Usage data: pages visited, features used, session time</li>
              <li>Approximate location based on IP</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>3. How We Use Your Information</h2>
            <ul>
              <li>Provide, maintain, and improve the Service</li>
              <li>Create and manage accounts</li>
              <li>Process payments and related transactions</li>
              <li>Enable event hosting and community memberships</li>
              <li>Prevent fraud and detect policy violations</li>
              <li>Send updates, notifications, and promotional content (with consent)</li>
              <li>Analyze usage patterns and improve user experience</li>
              <li>Comply with legal obligations</li>
            </ul>
          </div>

          <div className="legal-section">
  <h2>3A. Google & YouTube Data Usage</h2>
  <p>
    INVITS allows users to optionally connect their Google account to access YouTube features.
    This integration uses Google OAuth and the YouTube Data API to enable users to select
    and play videos from their own YouTube playlists within an invitation.
  </p>

  <p>
    When a user chooses to connect their YouTube account, INVITS may access the following data:
  </p>

  <ul>
    <li>View the user’s YouTube playlists</li>
    <li>View videos within those playlists</li>
  </ul>

  <p>
    This access is used solely to display and play selected YouTube content inside the INVITS app.
    INVITS does not upload, edit, download, store, or share YouTube videos or playlists.
  </p>

  <p>
    YouTube data is not stored on INVITS servers and is used only during active user sessions.
    Users can revoke INVITS access to their Google account at any time via their Google Account
    permissions settings.
  </p>

  <p>
    INVITS use and transfer of information received from Google APIs adheres to the
    Google API Services User Data Policy, including the Limited Use requirements.
  </p>
</div>


          <div className="legal-section">
            <h2>4. Information Sharing and Disclosure</h2>
            <h3>4.1 With Your Consent</h3>
            <p>We may share your information when you provide explicit consent.</p>

            <h3>4.2 Service Providers</h3>
            <p>Third-party providers that help us operate the platform, including:</p>
            <ul>
              <li>Payment processors</li>
              <li>Cloud hosting</li>
              <li>Analytics and email providers</li>
            </ul>

            <h3>4.3 Event Hosts and Community Members</h3>
            <p>
              Information related to events, invitations, or communities may be shared with organizers, hosts, 
              and participants to facilitate the Service.
            </p>

            <h3>4.4 Legal Requirements</h3>
            <p>We may disclose information if required by law or legal process.</p>
          </div>

          <div className="legal-section">
            <h2>5. Data Security</h2>
            <p>
              We implement technical and organizational measures to protect your information. However, no system 
              is 100% secure. Users are responsible for maintaining account confidentiality.
            </p>
          </div>

          <div className="legal-section">
            <h2>6. Data Retention</h2>
            <p>
              Data is retained as long as necessary to provide the Service, comply with legal obligations, and resolve disputes.
            </p>
          </div>

          <div className="legal-section">
            <h2>7. Your Rights</h2>
            <ul>
              <li>Access and update your account information</li>
              <li>Request deletion of your account via privacy@invits.co</li>
              <li>Opt-out of marketing communications</li>
              <li>Request a copy of your data in a structured, machine-readable format</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>8. Children's Privacy</h2>
            <p>The Service is not for users under 18. We do not knowingly collect info from children.</p>
          </div>

          <div className="legal-section">
            <h2>9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. Continued use of the Service constitutes acceptance.
            </p>
          </div>

          <div className="legal-section">
            <h2>10. Contact Us</h2>
            <p>
              For privacy-related questions, contact: <strong>privacy@invits.co</strong>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;
